<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop">
        <div class="bg-light">
          <v-toolbar color="primary" class="top-hero6" dark flat>
            <v-toolbar-title>Attach Review to home</v-toolbar-title>
          </v-toolbar>
          <div class="h-96 mt-1 overflow-auto">
            <div class="p-12 grid gap-5 lg:grid-cols-4 lg:max-w-none">
              <div
                v-for="rental in allHouses"
                :key="rental.id"
                class="rounded-lg shadow flex flex-col overflow-hidden"
              >
                <v-card>
                  <v-img :aspect-ratio="16 / 9" :src="rental.Images[0]">
                  </v-img>

                  <v-card-text>
                    <span
                      v-if="rental.Reviews"
                      class="absolute inset-x-0 top-0 m-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800"
                    >
                      Reviews: {{ rental.Reviews.length }}
                    </span>
                    <v-btn
                      @click="edit(rental)"
                      absolute
                      color="blue"
                      class="white--text"
                      style="margin-top: 3em"
                      fab
                      large
                      right
                      top
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>

                    <h3 class="display-1 font-weight-light blue--text mb-2">
                      {{ rental.StreetNumber }}
                      {{ rental.StreetName }}<br />
                      {{ rental.StreetSuffix }}
                    </h3>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </div>
          <!-- Modal -->
          <!-- This example requires Tailwind CSS v2.0+ -->
          <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpen">
            <div
              class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
              <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>

              <!-- This element is to trick the browser into centering the modal contents. -->
              <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
                >&#8203;</span
              >

              <div
                class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
              >
                <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <review-form
                    @clicked="isOpen = false"
                    :listing="selected"
                    :hide="true"
                  ></review-form>
                </div>
              </div>
            </div>
          </div>
          <!-- close Modal -->
        </div>

        <!-- Modal -->
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="fixed z-10  inset-0 overflow-y-auto" v-if="showForm">
          <div
            class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
          >
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
              class="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
              >&#8203;</span
            >

            <div
              class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <review-form
                  @clicked="showForm = false"
                  listing=""
                ></review-form>
              </div>
            </div>
          </div>
        </div>

        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="flex flex-col mt-8">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
            >
              <div
                class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Id
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Review
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Uploaded By
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <button
                          @click="editReview()"
                          type="button"
                          class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          Create Review
                        </button>
                      </th>
                      <th scope="col" class="relative px-6 py-3">
                        <span class="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Odd row -->
                    <tr
                      v-for="review in reviews"
                      :key="review.id"
                      class="bg-white"
                    >
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                      >
                        {{ review.id }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ review.name }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 overflow-hidden"
                      >
                        {{ review.review | shortText(120) }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 overflow-hidden"
                      >
                        {{ review.author.name }}
                      </td>
                      <td class="px-6 py-4 text-right text-sm font-medium">
                        <!-- <a  class="cursor-pointer text-indigo-600 hover:text-indigo-900">Edit</a> -->
                        <a
                          @click="removeReview(review)"
                          class="cursor-pointer ml-4 text-red-600 hover:text-red-900"
                          >Remove</a
                        >
                      </td>
                      <td class="px-6 py-4 text-right text-sm font-medium"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";
export default {
  name: "Houses",
  data() {
    return {
      selected: "",
      isOpen: false,
      images: [],
      allHouses: [],
      reviews: [],
      showForm: false
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  created() {
    this.getHomesByHouses();
    this.getReviews();
  },
  methods: {
    getReviews() {
      window.axios.get("/api/reviews").then(res => {
        this.reviews = res.data;
      });
    },
    getHomesByHouses() {
      window.axios.get("api/getHBhouses").then(res => {
        this.allHouses = res.data;
      });
    },
    uploadFiles(e) {
      this.images = e.target.files || e.dataTransfer.files;
      console.log(this.images);
    },
    closingModal() {
      this.isOpen = false;
      this.selected = "";
    },
    edit(item) {
      this.selected = item;
      this.isOpen = true;
    },
    editReview() {
      this.showForm = true;
    },
    removeReview(review) {
      window.axios.get("/api/removeReview/" + review.id).then(() => {
        this.getHomesByHouses();
        this.getReviews();
        Swal.fire({
          icon: "success",
          title: "Review successfully removed"
        });
      });
    },
    saveImages(id) {
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let filesImages = new FormData();
      $.each(this.images, function(key, image) {
        filesImages.append(`images[${key}]`, image);
      });
      filesImages.append("listingId", id);
      window.axios.post("/api/inventory", filesImages, config).then(() => {
        alert("Inventory Created");
      });
    }
  }
};
</script>
